import * as types from '../../types'
import Immutable from 'immutable'

const INITIAL_STATE = Immutable.fromJS({
    cafeterias: [],
    saving: false,
})

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.REPORTE1_REINICIAR_ESTADO:
            return INITIAL_STATE
        case types.REPORTE1_GUARDANDO:
            state = state.set('saving', action.payload)
            return state
        default:
            return state
    }
}